<template>
  <div class="subview places">
    <template v-if="!loading">
      <template v-if="!attraction.item.stream">
        <h2 class="places-title">Vos sièges</h2>
        <div
          v-for="place in order.tickets"
          :key="`place-${place.id}`"
          class="place"
        >
          <span
            v-if="place.title"
            class="place-value"
          >
            <span>{{ place.title }}</span>
          </span>
          <span class="place-label">
            {{ place.category }}<br/>
            {{ place.price.label }}
          </span>
          <span class="place-price">{{ place.price.value }} €</span>
        </div>

        <p class="places-disclaimer">Ces places sont attribuées automatiquement par le système. Si vous désirez changer de place, veuillez contacter <a href="mailto:Billetterie@theatredeliege.be">Billetterie@theatredeliege.be</a>.<br /> Merci d’avance.</p>
      </template>
      <template v-else>
        <h2 class="places-title">Spectacle en streaming</h2>
        <p class="places-text"><strong>Attention !</strong><br><br>ce spectacle sera disponible en streaming sur internet, pas besoin de vous déplacer jusqu’au théâtre. Il suffit simplement de :</p>
        <ul class="places-list">
          <li>Réserver votre place</li>
          <li>Nous transmettre vos coordonnées</li>
          <li>Un mail avec le code d’accès au spectacle vous sera envoyé</li>
          <li>Retrouvez également votre code d’accès dans l’espace “Mes billets” de l’app</li>
        </ul>
      </template>

      <!-- <a class="places-link" href="#"> Voir l’emplacement de vos places <sprite :type="'chevron-right'" :width="5" :height="7"/></a> -->

      <pagination
        :back="true"
        @prev="onPrev"
        @next="onNext"
      />
    </template>
  </div>
</template>

<script>
// import Sprite from '@/components/components/Sprite.vue';
import Pagination from '@/components/partials/Pagination.vue';

export default {
  components: {
    // Sprite,
    Pagination
  },
  computed: {
    order() {
      if (!this.$store.state.basket.datas.order) {
        return {};
      }

      return this.$store.state.basket.datas.order;
    },
    attraction() {
      return this.$store.state.basket.attraction;
    },
    loading() {
      return this.$store.state.basket.requests !== 0;
    }
  },
  methods: {
    onPrev() {
      this.$router.push({ name: 'BasketTickets' });
    },
    onNext() {
      this.$router.push({ name: 'BasketInformations' });
    }
  }
};
</script>

<style lang="scss" scoped>
.places {
  display: flex;
  flex-direction: column;
  align-items: center;

  &-title {
    @include padding(null null 25px);
    @include margin(null null 8px);
    width: 100%;
    border-bottom: 1px solid $grey-light-alternate;
    font-size: rem(22px);
    line-height: (25 / 22);
  }

  &-text {
    margin-top: 24px;
    font-size: rem(14px);
    line-height: (16 / 14);

    strong {
      color: $primary;
    }
  }

  &-list {
    margin-top: 24px;

    li {
      @include padding(null null null 20px);
      position: relative;
      font-size: rem(14px);
      line-height: (16 / 14);

      &::before {
        @include position(absolute, 0 null null 0);
        content: '•';
        color: $primary;
      }

      &:not(:first-child) {
        margin-top: 14px;
      }
    }
  }

  .place {
    @include padding(24px null);
    @include font('secondary', 'regular');
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    outline: none;
    font-size: rem(19px);
    line-height: (23 / 19);

    &-value {
      @include margin(null 24px null null);
      @include size(53px);
      display: flex;
      position: relative;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      background-color: $black-light;
      border-radius: 50%;

      span {
        @include position(absolute, 50% null null 0);
        @include padding(2px null null);
        @include size(100%, auto);
        transform: translateY(-50%);
        text-align: center;
      }
    }

    &-label {
      @include margin(null 20px null null);
      @include padding(2px null null);
    }

    &-price {
      @include margin(null null null auto);
      @include font('secondary', 'medium');
      flex-shrink: 0;
      font-size: rem(20px);
      line-height: (24 / 20);
    }

    + .place {
      border-top: 1px dashed $grey;
    }
  }

  &-disclaimer {
    @include margin(24px null null);
    font-size: rem(14px);
    line-height: (16 / 14);

    a {
      color: $primary;
      text-decoration: underline;
    }
  }

  &-link {
    @include font('secondary', 'regular');
    @include margin(30px null null);
    color: $primary;
    font-size: rem(14px);
    line-height: (17 / 14);

    .svg {
      @include margin(null null null 3px);
      fill: $primary;
    }
  }
}
</style>
